import { defineStore } from "pinia";
// 用户相关
const useUser = defineStore("user", {
    state() {
        return {
            user: {}
        };
    }
});

export { useUser };
